import Turbolinks from 'turbolinks';

Turbolinks.setRootSelector('#vueApp');
Turbolinks.start();
